import { Component, Output, OnInit, Input, EventEmitter } from '@angular/core';
import { TableActionService } from '../../../custom-table/services/table-action.service';

type Actions = 'createTrip'
  | 'addToTrip'
  | 'cancel'
  | 'globe'
  | 'delete'
  | 'deleteFromTrip'
  | 'resendInvitation'
  | 'sendInvitation'
  | 'offerDiscount'
  | 'publish'
  | 'unpublish'
  | 'addNote'
  | 'viewNotes'
  ;
type Dictionary<K extends PropertyKey, T> = {
  [P in K]?: T;
};

@Component({
  selector: 'app-action-menu-view',
  templateUrl: './action-menu-view.component.html',
  styleUrls: ['./action-menu-view.component.scss'],
})
export class ActionMenuViewComponent implements OnInit {
  @Input() model?: unknown;

  @Output() OnCreateTripClick = new EventEmitter<unknown>();
  @Output() OnAddToTripClick = new EventEmitter<unknown>();
  @Output() OnCancelClick = new EventEmitter<unknown>();
  @Output() OnGlobeClick = new EventEmitter<unknown>();
  @Output() OnDeleteClick = new EventEmitter<unknown>();

  @Input() isVertical = false;
  @Output() OnResendInvitationClick = new EventEmitter<unknown>();

  @Input() config: Dictionary<Actions, ActionConfiguration> = {};
  actions: ActionConfiguration[] = [];

  constructor(private readonly tableActionService: TableActionService) {
  }

  getConfig = (config: Dictionary<Actions, ActionConfiguration>) => ({
    createTrip: {
      icon: 'add_circle',
      header: 'Create Trip',
      emitter: this.OnCreateTripClick,
      isDisplayed: false,
      ...config.createTrip,
    },
    addToTrip: {
      icon: 'local_shipping',
      header: 'Add To Trip',
      emitter: this.OnAddToTripClick,
      isDisplayed: false,
      ...config.addToTrip,
    },
    cancel: {
      icon: 'cancel',
      header: 'Cancel',
      emitter: this.OnCancelClick,
      isDisplayed: false,
      ...config.cancel,
    },
    globe: {
      icon: 'language',
      header: 'Globe',
      emitter: this.OnGlobeClick,
      isDisplayed: false,
      ...config.globe,
    },
    resendInvitation: {
      icon: 'send',
      header: 'Resend Invite',
      isDisplayed: false,
      ...config.resendInvitation,
    },
    sendInvitation: {
      icon: 'send',
      header: 'Send Invite',
      isDisplayed: false,
      ...config.sendInvitation,
    },
    offerDiscount: {
      icon: 'local_offer',
      header: 'Offer Discount',
      isDisplayed: false,
      ...config.offerDiscount,
    },
    publish: {
      icon: 'send',
      header: 'Publish',
      isDisplayed: false,
      ...config.publish,
    },
    unpublish: {
      icon: 'send',
      header: 'Unpublish',
      isDisplayed: false,
      ...config.unpublish,
    },
    addNote: {
      icon: 'edit',
      header: 'Add Note',
      emitter: this.OnResendInvitationClick,
      isDisplayed: false,
      ...config.addNote,
    },
    viewNotes: {
      icon: 'remove_red_eye',
      header: 'View Notes',
      isDisplayed: false,
      ...config.viewNotes,
    },
    deleteFromTrip: {
      icon: 'delete',
      header: 'Remove From Trip',
      emitter: this.OnDeleteClick,
      isDisplayed: false,
      ...config.deleteFromTrip,
    },
    delete: {
      icon: 'delete',
      header: 'Delete',
      emitter: this.OnDeleteClick,
      isDisplayed: false,
      ...config.delete,
    },
  })

  ngOnInit() {
    this.config = this.getConfig(this.config);
    this.actions = Object.values(this.config).filter(x => x.isDisplayed);
  }

  click(action: ActionConfiguration) {
    action.emitter && action.emitter.emit();
    action.click && action.click(this.model, this.tableActionService);
  }
}

class ActionConfiguration {
  header: string;
  icon: string;
  emitter?: EventEmitter<unknown>;
  isDisplayed: boolean;
  click: (model: unknown, actionService: TableActionService) => void;
}
